import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const Banner01 = () => {
  const navigate = useNavigate();

  const data = [
    { id: 0, src: "/assets/img/main6.png", to: "/AboutUs/Goodbye" },
    { id: 1, src: "/assets/img/main1.png", to: "/AboutUs/Question" },
    { id: 2, src: "/assets/img/main2.png", to: "/AboutUs/Communication" },
    { id: 3, src: "/assets/img/main3.png", to: "/AboutUs/Lifestyle" },
    { id: 4, src: "/assets/img/main4.png", to: "/AboutUs/Story" },
    { id: 5, src: "/assets/img/main5.png", to: "/AboutUs/Healthy" },
    { id: 6, src: "/assets/img/main6.png", to: "/AboutUs/Goodbye" },
    { id: 7, src: "/assets/img/main1.png", to: "/AboutUs/Question" },
  ];

  const [activeSlide, setActiveSlide] = useState(data[1].id);
  const [isMoving, setIsMoving] = useState(false);

  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const mouseDownX = useRef(null);
  const isDragging = useRef(false);

  const minSwipeDistance = 30;
  const minClickDistance = 5;

  const onTouchStart = (e) => {
    touchStartX.current = e.targetTouches[0].clientX;
    touchEndX.current = null;
    isDragging.current = false;
  };

  const onTouchMove = (e) => {
    touchEndX.current = e.targetTouches[0].clientX;
    isDragging.current = true;
  };

  const onTouchEnd = () => {
    if (!touchStartX.current || !touchEndX.current) return;
    const distance = touchStartX.current - touchEndX.current;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      setIsMoving(true);
      setActiveSlide((prev) =>
        prev < data[data.length - 1].id ? prev + 1 : prev
      );
    } else if (isRightSwipe) {
      setIsMoving(true);
      setActiveSlide((prev) => (prev > data[0].id ? prev - 1 : prev));
    }
  };

  const onMouseDown = (e) => {
    mouseDownX.current = e.clientX;
    isDragging.current = false;
  };

  const onMouseMove = (e) => {
    if (mouseDownX.current !== null) {
      const distance = Math.abs(e.clientX - mouseDownX.current);
      if (distance > minClickDistance) {
        isDragging.current = true;
      }
    }
  };

  const onMouseUp = (e, to) => {
    if (!mouseDownX.current) return;
    const distance = Math.abs(e.clientX - mouseDownX.current);

    if (distance < minClickDistance && !isDragging.current) {
      navigate(to);
    } else {
      setIsMoving(true);
      const isLeftSwipe = e.clientX < mouseDownX.current;
      if (isLeftSwipe) {
        setActiveSlide((prev) =>
          prev < data[data.length - 1].id ? prev + 1 : prev
        );
      } else {
        setActiveSlide((prev) => (prev > data[0].id ? prev - 1 : prev));
      }
    }
  };

  const onTransitionEnd = () => {
    setIsMoving(false);
    if (activeSlide === data[0].id) {
      setActiveSlide(data[data.length - 2].id);
    } else if (activeSlide === data[data.length - 1].id) {
      setActiveSlide(data[1].id);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIsMoving(true);
      setActiveSlide((prev) =>
        prev === data[data.length - 1].id ? data[1].id : prev + 1
      );
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="overflow-hidden bg-white rounded-2xl relative m1Swiper"
      style={{
        boxShadow: "10px 12px 16px 0px rgba(35, 48, 59, 0.10)",
      }}
    >
      {/* slider */}
      <ul
        className={`flex items-stretch flex-nowrap ${
          isMoving ? "transition-transform duration-300 ease-in-out" : ""
        }`}
        style={{
          transform: `translateX(-${activeSlide * 100}%)`,
        }}
        onTransitionEnd={onTransitionEnd}
      >
        {data.map((item) => (
          <li key={item.id} style={{ flex: "0 0 100%" }}>
            <img
              src={item.src}
              alt=""
              className="w-full cursor-pointer"
              style={{ userSelect: "none", WebkitUserDrag: "none" }}
              onTouchStart={onTouchStart}
              onTouchMove={onTouchMove}
              onTouchEnd={onTouchEnd}
              onMouseDown={onMouseDown}
              onMouseMove={onMouseMove}
              onMouseUp={(e) => onMouseUp(e, item.to)}
            />
          </li>
        ))}
      </ul>

      {/* Indicator */}
      <ul className="absolute sm:left-8 sm:bottom-10 left-4 bottom-6 flex items-center gap-2">
        {Array.from({ length: data.length - 2 }, (_, index) => index + 1).map(
          (num) => (
            <li
              key={num}
              className={`h-2 rounded-full ${
                num === activeSlide ? "bg-[#111111] w-7" : "bg-[#DDDDDD] w-2"
              }`}
              style={{ transition: "all 0.1s ease" }}
            />
          )
        )}
      </ul>
    </div>
  );
};

export default Banner01;
